import {Component, OnInit} from '@angular/core';
import {Store} from '@ngxs/store';
import {combineLatest, Observable, timer} from 'rxjs';
import {map} from 'rxjs/operators';
import {TimeUtils} from '../../engine/time-utils';

@Component({
  selector: 'gg-anons',
  templateUrl: './anons.component.html',
  styleUrls: ['./anons.component.scss']
})
export class AnonsComponent implements OnInit {
  apiData$ = this.store.select(state => state.player.apiData);
  isStarted$ = this.store.select(state => state.player.isStarted);

  isAnonsVisible$: Observable<boolean>;
  timer$: Observable<any>;

  constructor(private store: Store) {
  }

  ngOnInit() {
    this.timer$ = combineLatest([timer(0, 1000), this.apiData$]).pipe(map(([i, apiData]) => {
      if (!apiData.broadcast) {
        return null;
      }
      const timeDiff = (new Date(apiData.broadcast.broadcast_start.replace(/-/g, '/'))).getTime() - Date.now();
      return timeDiff >= 0 ? TimeUtils.secondsToTime(timeDiff / 1000) : '';
    }));

    this.isAnonsVisible$ = combineLatest([this.apiData$, this.isStarted$]).pipe(map(([apiData, isStarted]) => {
      return !isStarted && apiData && apiData.channel_status !== 'online' && apiData.broadcast && apiData.broadcast.broadcast_start;
    }));
  }

}
